export default __webpack_public_path__ + "static/media/WonderWheelPromotionalTool.cbab1ffa.png";